export const AnimationPaths = [
  "/ElectronicForm",
  "/main",
  "/CurrentPatients",
  "/PatientList",
  "/CompleteProfileUser",
  "/SearchPatientForErja",
  "/about",
  "/UploadOnCallDocs",
  "/ContactUs",
  "/ListServiceConfer",
  "/BankAccountList",
  "/ChangePasswrod",
  "/ServiceReportSummary",
  "/testFlight",
  "/AddNewConfer",
  "/EditConferService",
  "/AddNewElectronicForm",
  "/messages",
  "/ReferTo",
  "*",
];
